import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

function TransitionEffect({ isInView }) {
  const [triggerAnimation, setTriggerAnimation] = useState(false);

  useEffect(() => {
    if (isInView) {
      // Add a delay before triggering the animation
      const timer = setTimeout(() => {
        setTriggerAnimation(true);
      }, 500); // 500ms delay

      return () => clearTimeout(timer); // Cleanup the timer on unmount
    } else {
      setTriggerAnimation(false); // Reset when out of view
    }
  }, [isInView]);

  return (
    <>
      <motion.div
        className="absolute top-0 bottom-0 right-full w-screen h-screen z-30 bg-[#ff4d5a] dark:bg-[#ff7d85]"
        initial={{ x: '100%', width: '100%' }}
        animate={triggerAnimation ? { x: '0%', width: '0%' } : {}}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute top-0 bottom-0 right-full w-screen h-screen z-30 bg-[#ff934f] dark:bg-[#ffae83]"
        initial={{ x: '100%', width: '100%' }}
        animate={triggerAnimation ? { x: '0%', width: '0%' } : {}}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
      />
    </>
  );
}

export default TransitionEffect;
